// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/select2/dist/css/select2.min.css
// module id = A2Qj
// module chunks = 9